import script from "./GestionVariables.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionVariables.vue?vue&type=script&setup=true&lang=js"

import "./GestionVariables.vue?vue&type=style&index=0&id=041b5988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041b5988"]])

export default __exports__